import {BDProjectsModule, BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';

import {ActionsMenuComponent} from './components/projects-table-components/tables_shared_components/actions-menu/actions-menu.component';
import {AddSupplyCategorisedModalComponent} from './components/add-supply-categorised-modal/add-supply-categorised-modal.component';
import {AmountInputComponent} from './components/input-components/amount-input/amount-input.component';
import {BranchSelectComponent} from './components/input-components/branch-select/branch-select.component';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {ColumnHeaderComponent} from './components/projects-table-components/tables_shared_components/column-header/column-header.component';
import {CommonModule} from '@angular/common';
import {ControlledTextareaComponent} from './components/input-components/controlled-textarea/controlled-textarea.component';
import {
    DeleteAttentionModalComponent
} from './components/projects-table-components/project_table/delete-attention-modal/delete-attention-modal.component';
import {DevicesTableModalComponent} from './components/projects-table-components/project_table/devices-table-modal/devices-table-modal.component';
import {
    DialogStep2SectionControllerComponent
} from './components/section-components/dialog-step2-section-controller/dialog-step2-section-controller.component';
import {EditModalService} from './services/edit-modal.service';
import {FileSizeAttentionModalComponent} from './components/file-size-attention-modal/file-size-attention-modal.component';
import {ProjectFilterComponent} from './components/projects-table-components/project_table/filter/project-filter.component';

import {FormsModule} from '@angular/forms';
import {IProductService} from './services/product.service.interface';
import {IProjectService} from './services/project.service.interface';
import {InfoIconButtonComponent} from './components/info-icon-button/info-icon-button.component';
import {ItemLabelInfoModalComponent} from './components/item-label-info-modal/item-label-info-modal.component';
import {ModalVisibilityService} from './services/modal-visibility.service';
import {MultiContactsWidgetComponent} from './components/multi-contacts-widget/multi-contacts-widget.component';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxMaskModule} from 'ngx-mask';
import {PriceInputComponent} from './components/input-components/price-input/price-input.component';
import {ProductLabelComponent} from './components/product-label/product-label.component';
import {
    ProjectHistoryTableModalComponent
} from './components/projects-table-components/project_table/project-history-table-modal/project-history-table-modal.component';
import {
    ProjectsDevicesTableComponent
} from './components/section-components/devices-table/devices-table.component';
import {
    ProjectsDialogStep5SectionsControllerComponent
} from './components/section-components/dialog-step5-sections-controller/dialog-step5-sections-controller.component';
import {
    ProjectsDialogStep6SectionsControllerComponent
} from './components/section-components/dialog-step6-sections-controller/dialog-step6-sections-controller.component';
import {ProjectsEditModalComponent} from './components/edit-modal/edit-modal.component';
import {ProjectsEmployeeEditorComponent} from './components/section-components/employee-editor/employee-editor.component';
import {ProjectsEndUserDataEditorComponent} from './components/section-components/end-user-data-editor/end-user-data-editor.component';
import {
    ProjectsGeneralSuppliesShoppingTableComponent
} from './components/section-components/general-supplies-shopping-table/general-supplies-shopping-table.component';
import {MerchantUserInfoViewerComponent} from './components/section-components/merchant-info-viewer/merchant-user-info-viewer.component';
import {
    ProjectsPrintSmartSuppliesShoppingTableComponent
} from './components/section-components/projects-print-smart-supplies-shopping-table/print-smart-supplies-shopping-table.component';
import {ProjectsProjectDataEditorComponent} from './components/section-components/project-data-editor/project-data-editor.component';
import {
    ProjectsProjectDocumentsLoaderComponent
} from './components/section-components/project-documents-loader-component/project-documents-loader.component';
import {
    ProjectsProjectDocumentsViewerComponent
} from './components/section-components/project-documents-viewer/project-documents-viewer.component';
import {ProjectsRootComponent} from './pages/root/root.page';
import {
    ProjectsSimpleSectionViewerComponent
} from './components/section-components/simple-section-viewer/simple-section-viewer.component';
import {ProjectsTableComponent} from './components/projects-table-components/project_table/projects-table/projects-table.component';
import {ProjectsTableRowComponent} from './components/projects-table-components/project_table/projects-table-row/projects-table-row.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {SmallTextInfoModalComponent} from './components/small-text-info-modal/small-text-info-modal.component';
import {ProjectsStepperComponent} from './components/stepper/projects-stepper.component';
import {StripModalComponent} from './components/strip-modal/strip-modal.component';
import {SuppliesViewerComponent} from './components/section-components/supplies-viewer/supplies-viewer.component';
import {SupplyOptionTableComponent} from './components/section-components/supply-option-table/supply-option-table.component';
import {ProjectsTableService} from './services/projects-table.service';
import {ValidatorFnDirective} from './directives/validator-fn.directive';

import {
    WarrantyNotesEditorComponent
} from './components/section-components/warranty-notes-editor/warranty-notes-editor.component';
import {WorkingDayDirective} from './directives/working-day.directive';
import {ProjectDealerAppService} from './services/project.dealerapp.service.implementation';
import {ProjectIsLockedModalComponent} from './components/project-is-locked-modal/project-is-locked-modal.component';
import {
    SupplyAcquisitionTypeInputComponent
} from './components/input-components/supply-acquisition-type-input/supply-acquisition-type-input.component';
import {
    ProjectStatusProgressBarComponent
} from './components/projects-table-components/project_table/project-status-progress-bar/project-status-progress-bar.component';
import {
    OfferTextModulesEditorComponent
} from './components/section-components/offer-text-modules-editor/offer-text-modules-editor.component';
import {EditModalCustomPriceTableService} from './services/edit-modal-custom-price-table.service';
import {ProductDealerAppService} from './services/product.dealerapp.service.implementation';
import {
    ProjectsPriceApprovalTableComponent
} from './components/projects-table-components/price-approval-table/projects-price-approval-table/projects-price-approval-table.component';
import { ProjectPriceApprovalTableRowComponent } from './components/projects-table-components/price-approval-table/project-price-approval-table-row/project-price-approval-table-row.component';
import { FilteredPriceApprovalProjectTableComponent } from './components/projects-table-components/price-approval-table/filtered-price-approval-project-table/filtered-price-approval-project-table.component';
import {FilteredProjectTableComponent} from './components/projects-table-components/project_table/filtered-project-table/filtered-project-table.component';
import { SummaryModalComponent } from './components/summary-modal/summary-modal.component';
import { HoverHandlerComponent } from './components/hover-handler/hover-handler.component';
import { RPriceInfoModalComponent } from './components/section-components/r-price-info-modal/r-price-info-modal.component';
import { PriceApprovalCommentModalComponent } from './components/price-approval-comment-modal/price-approval-comment-modal.component';
import { QuotesModalComponent } from './components/quotes-modal/quotes-modal.component';
import {ProjectsBodyScrollingService} from './services/projects-body-scrolling.service';
import { HoveredDisabledInputComponent } from './components/hovered-disabled-input/hovered-disabled-input.component';
import {ProjectsContactsWidgetService} from './services/projects-contacts-widget.service';
import {IProjectsContactService} from './services/projects-contact.service.interface';
import {ProjectsContactService} from './services/projects-contact.service.implementation';
import { NoOrderItemsInfoComponent } from './components/section-components/no-order-items-info/no-order-items-info.component';
import { DialogStep4SectionControllerComponent } from './components/section-components/dialog-step4-section-controller/dialog-step4-section-controller.component';
import { AddDevicesToOrderModalComponent } from './components/add-devices-to-order-modal/add-devices-to-order-modal.component';
import { AddAdditionalItemToOrderModalComponent } from './components/add-additional-item-to-order-modal/add-additional-item-to-order-modal.component';
import { EmptyContainersFormInvalidatorComponent } from './components/section-components/empty-containers-form-invalidator/empty-containers-form-invalidator.component';
import {ContainerUtilsService} from './services/container-utils.service';
import {ContainerListsUtilsService} from './services/container-lists-utils.service';
import { ProjectServicesTableComponent } from './components/section-components/project-services-table/project-services-table.component';
import { DevicesTableViewerComponent } from './components/section-components/devices-table-viewer/devices-table-viewer.component';
import { AdditionalItemsTableViewerComponent } from './components/section-components/additional-items-table-viewer/additional-items-table-viewer.component';
import {AdditionalItemsExtensionEditorComponent} from './components/section-components/additional-items-extension-editor/additional-items-extension-editor.component';
import {ProjectAdditionalItemsTableComponent} from './components/section-components/additional-items-table/additional-items-table.component';
import {ProjectProductSummaryViewerComponent} from './components/section-components/product-summary-viewer/product-summary-viewer.component';
import { ModalDataProcessingAgreementComponent } from '../data-processing-agreement/components/modal-data-processing-agreement/modal-data-processing-agreement.component';
import {ProjectsFilterModalComponent } from './components/projects-filter-modal/projects-filter-modal.component';
import {SharedFormsModule} from '../../shared-forms/shared-forms.module';

// @ts-ignore
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        NgSelectModule,
        NgxMaskModule.forRoot(),
        CdkStepperModule,
        BDSharedModule,
        BDProjectsModule.forRoot(false),
        RouterModule,
        SharedFormsModule
    ],
    declarations: [
        // Pages
        ProjectsRootComponent,

        // Components
        ActionsMenuComponent,
        AddSupplyCategorisedModalComponent,
        AmountInputComponent,
        BranchSelectComponent,
        ColumnHeaderComponent,
        ControlledTextareaComponent,
        DeleteAttentionModalComponent,
        DevicesTableModalComponent,
        DialogStep2SectionControllerComponent,
        FileSizeAttentionModalComponent,
        ProjectFilterComponent,
        FilteredProjectTableComponent,
        InfoIconButtonComponent,
        ItemLabelInfoModalComponent,
        MultiContactsWidgetComponent,
        PriceInputComponent,
        ProductLabelComponent,
        ProjectHistoryTableModalComponent,
        ProjectsDevicesTableComponent,
        ProjectsDialogStep5SectionsControllerComponent,
        ProjectsDialogStep6SectionsControllerComponent,
        ProjectsEditModalComponent,
        ProjectsEmployeeEditorComponent,
        ProjectsEndUserDataEditorComponent,
        ProjectsGeneralSuppliesShoppingTableComponent,
        MerchantUserInfoViewerComponent,
        ProjectsPrintSmartSuppliesShoppingTableComponent,
        ProjectsProjectDataEditorComponent,
        ProjectsProjectDocumentsLoaderComponent,
        ProjectsProjectDocumentsViewerComponent,
        ProjectsSimpleSectionViewerComponent,
        ProjectsTableComponent,
        ProjectsTableRowComponent,
        SmallTextInfoModalComponent,
        ProjectsStepperComponent,
        StripModalComponent,
        SuppliesViewerComponent,
        SupplyOptionTableComponent,
        AdditionalItemsExtensionEditorComponent,
        ProjectProductSummaryViewerComponent,
        WarrantyNotesEditorComponent,

        // directives

        ValidatorFnDirective,
        WorkingDayDirective,
        ProjectIsLockedModalComponent,
        SupplyAcquisitionTypeInputComponent,
        ProjectStatusProgressBarComponent,
        OfferTextModulesEditorComponent,
        ProjectsPriceApprovalTableComponent,
        ProjectPriceApprovalTableRowComponent,
        FilteredPriceApprovalProjectTableComponent,
        SummaryModalComponent,
        HoverHandlerComponent,
        RPriceInfoModalComponent,
        PriceApprovalCommentModalComponent,
        QuotesModalComponent,
        HoveredDisabledInputComponent,
        NoOrderItemsInfoComponent,
        DialogStep4SectionControllerComponent,
        ProjectAdditionalItemsTableComponent,
        AddDevicesToOrderModalComponent,
        AddAdditionalItemToOrderModalComponent,
        EmptyContainersFormInvalidatorComponent,
        ProjectServicesTableComponent,
        DevicesTableViewerComponent,
        AdditionalItemsTableViewerComponent,
        ModalDataProcessingAgreementComponent,
        ProjectsFilterModalComponent,
    ],
    providers: [
        // {provide: IProjectService, useClass: ProjectDealerAppService},
        // {provide: IProductService, useClass: MockedProductService},
        {provide: IProjectsContactService, useClass: ProjectsContactService},
        EditModalService,
        ContainerListsUtilsService,
        ContainerUtilsService,
        EditModalCustomPriceTableService,
        ModalVisibilityService,
        ProjectsTableService,
        ProjectsBodyScrollingService,
        ProjectsContactsWidgetService,
    ],
    exports: [
        // Pages
        ProjectsRootComponent,
    ]
})

export class ProjectsModule {
    public static forRoot(): ModuleWithProviders<ProjectsModule> {
        return {
            ngModule: ProjectsModule,
            providers: [
                {provide: IProjectService, useClass: ProjectDealerAppService},
                {provide: IProductService, useClass: ProductDealerAppService},
            ],
        };
    }
}
